// Mock data for MINDESIGN ENTERPRISES

export const heroData = {
  tagline: "MINDESIGN ENTERPRISES",
  subtitle: "Empowering Minds, Designing Legacies",
  description: "Your Life, Redesigned.",
  founderName: "Jose Francisco Rodriguez Jr."
};


// NFT Collection Data
export const nftData = [
  {
    id: 1,
    title: "Genesis Episode 1 Master 1-of-1",
    description: "THE ORIGINAL - MINDESIGN ENTERPRISES. The first episode origin story featuring Chokey and Hackenberry. 'Hack! THE METER! It's on THREE!' A collector's masterpiece with 1-of-1 digital signature.",
    collection: "Genesis Master",
    rarity: "Legendary",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/nft_genesis_ep1_master.png`
  },
  {
    id: 2,
    title: "The Galvanized Collection - Volumes I-V",
    description: "THE MINDESIGN ENTERPRISES GENESIS GALLERY. Unique Master Print 1-of-1 Collection. Genesis Minted. Stored in the SD Vault. Features The Icons: Chokey & Hackenberry Genesis Rare PFPs and The Genesis Comic Eps 1-5.",
    collection: "Galvanized Collection",
    rarity: "Legendary",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/nft_galvanized_collection.png`
  },
  {
    id: 3,
    title: "MINDESIGN PRESENTS - Hackenberry & Chokey",
    description: "Genesis Master 1-of-1. Mrs. Seem 1-of-1. The iconic duo reimagined in stunning detail. Artist: C.Grape | MINDESIGN.",
    collection: "Genesis Master",
    rarity: "Rare",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/nft_mindesign_presents.png`
  },
  {
    id: 4,
    title: "Chokey & Hackenberry - Genesis Rare PFPs",
    description: "CHARACTER RARE. The original Genesis Master profile pictures. 1-of-1 exclusive collectible featuring both mascots.",
    collection: "Genesis Master",
    rarity: "Rare",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/nft_chokey_hackenberry_rare.png`
  },
  {
    id: 5,
    title: "Genesis Episode 1 - Compact Master",
    description: "THE ORIGINAL - MINDESIGN ENTERPRISES. Compact edition of the Genesis Master 1-of-1.",
    collection: "Genesis Master",
    rarity: "Rare",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/nft_genesis_master.png`
  },
  {
    id: 6,
    title: "Chokey & Hackenberry - 3D Genesis",
    description: "HYPER-REALISTIC 3D RENDER. The iconic duo brought to life in stunning photorealistic detail. Chokey the Bear and Hackenberry the California Raisin like you've never seen them before. Ultra-rare 1-of-1.",
    collection: "Genesis 3D",
    rarity: "Legendary",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_hackenberry_3d.png`
  },
  {
    id: 7,
    title: "THE REDACTED: Original Genesis 1 Collectible",
    description: "G1 REDACTED COLLECTIBLE. The iconic helmet with pulsing code fractal pattern. Item Type: Collectible Helmet. Origin: The Forge. LEGENDARY 1/1. M.D.E. CERTIFIED.",
    collection: "Genesis 1",
    rarity: "Legendary",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/nft_redacted_helmet_g1.png`
  },
  {
    id: 8,
    title: "THE REDACTED: Full Genesis 1 Master",
    description: "G1 REDACTED COLLECTIBLE. Full body masterpiece featuring the enigmatic figure. Asset Type: G1 Redacted COLLECTIBLE. Script Data: A pulsing line of the code fractal pattern. LEGENDARY 1/1. Origin: The Forge.",
    collection: "Genesis 1",
    rarity: "Legendary",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/nft_redacted_full_g1.png`
  },
  {
    id: 9,
    title: "THE RESTORATION - Pulse: Genesis 2 Collectible",
    description: "THE HUMMINGBIRD PROTOTYPE. Pulse Genesis 2 Collectible. Item Type: Hummingbird Prototype. Origin: The Forge. LEGENDARY 1/1. From The Lion and The Hummingbird saga.",
    collection: "Genesis 2",
    rarity: "Legendary",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/nft_restoration_g2.png`
  },
  {
    id: 10,
    title: "THE LION: GAUNTLET - Guardian Genesis 3",
    description: "GUARDIAN'S GAUNTLET. Genesis 3 Collectible. Item Type: Guardian's Gauntlet. Origin: The Forge. LEGENDARY 1/1. The power of the Lion channeled through ancient armor.",
    collection: "Genesis 3",
    rarity: "Legendary",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/nft_lion_gauntlet_g3.png`
  },
  {
    id: 11,
    title: "VANE & RYX: Genesis 1 - The Frequency & The Dominance",
    description: "GENESIS 1: VANE AND RYX. Dual NFT featuring VANE 'The Frequency' in green matrix energy and RYX 'The Dominance' commanding the digital realm. Two forces. One destiny. LEGENDARY 1/1.",
    collection: "Genesis 1",
    rarity: "Legendary",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/nft_vane_ryx_genesis1.png`
  },
  {
    id: 12,
    title: "Guardian Angel: G1-G2 Bridge - Social Reclamation",
    description: "MINDESIGN ENTERPRISES LLC JFRJR ORIGINAL G1-G2 NFT. Verifiable Digital Ownership of Restoration Assets. G1: Peer-to-Peer Social Reclamation - Direct Action, Manual Miracles. G2: Proprietary Mesh Infrastructure - Sector Stabilization, Statewide Connectivity. THE LEGACY - Social Restoration is not a request. It is a RECLAMATION.",
    collection: "Guardian Angel Bridge",
    rarity: "Legendary",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/nft_guardian_angel_bridge_v2.png`
  }
];


// REDACTED Concert Track
export const redactedTrack = {
  id: 56,
  title: "THE SHINE",
  artist: "THE REDACTED",
  duration: "4:32",
  genre: "Electronic/Rock",
  description: "Enter the void with THE REDACTED - The Enigma. Experience immersive 3D concert universe.",
  isRedacted: true
};

// THE REDACTED Band Artwork
export const redactedArtwork = {
  bandLive: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/REDACTED_band_live.png`,
  enigmaDuo: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/REDACTED_enigma_duo.png`,
  comicOrigin: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/REDACTED_comic_origin.png`,
  comicDraconic: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/REDACTED_comic_draconic.png`
};

// THE DINOSAURS Band Data
export const dinosaursBand = {
  name: "THE DINOSAURS",
  tagline: "EXTINCTION IS NOT THE OPTION.",
  description: "Rock legends who refuse to go extinct. When the meteor hit, they just turned up the volume.",
  bandImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/dinosaurs_band.png`,
  venueImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/dinosaur_bar.png`
};

// Proud Partners — active links shown on landing page
export const proudPartnersData = [
  // Sample entry — replace with real partners as they onboard.
  // {
  //   id: 1,
  //   name: "Partner Name",
  //   tagline: "Short description of the partnership.",
  //   url: "https://partner-website.com",
  //   tier: "Founding",
  //   logo: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/partner_logo.png`
  // }
];

export const literaryWorksData = [
  {
    id: 1,
    title: "Meth Chronicles: The New Ice Age",
    description: "WINTER HAS COME FOR US ALL. 2027. Raw honesty meets brutal reality in this unflinching journey through ice and fire.",
    format: ["Book", "eBook", "Audiobook", "Movie"],
    category: "Gritty Reality",
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/meth_chronicles_ice_age.png`
  },
  {
    id: 2,
    title: "Bull Island",
    description: "A MINDESIGN ENTERPRISES & JFRJR Original. Four friends walking the railroad tracks into adventure, mystery, and the wild heart of the island.",
    format: ["Book", "TV Series", "Movie"],
    category: "Gritty Reality",
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/bull_island_cover.png`
  },
  {
    id: 3,
    title: "For The Love",
    description: "Some dreams just need a little magic. A heartwarming Disney-Pixar style story about football, family, and believing in the impossible at AT&T Stadium.",
    format: ["Book", "Movie"],
    category: "Inspirational",
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/for_the_love_cover.png`
  },
  {
    id: 4,
    title: "A Moment With God",
    description: "A SPIRITUAL ODYSSEY through faith, doubt, and enlightenment. Written from the North Tower of the Dallas County Jail during COVID — raw, unedited daily testimonies on the Chrysalis Moment, the root of fear, addiction recovery, systemic injustice, racism, and the path back to the Father. Live More · Love More · Laugh More · Give More.",
    format: ["Book", "eBook", "Memoir"],
    category: "Spiritual Journey",
    isNew: true,
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/moment_with_god_cover.png`
  },
  {
    id: 5,
    title: "The Filter",
    description: "ARCHITECTS. A cyberpunk thriller exploring the line between perception and reality. What you see isn't always what's there.",
    format: ["Book", "Screenplay", "Movie"],
    category: "Sci-Fi Thriller",
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/the_filter_cover.png`
  },
  {
    id: 6,
    title: "The Yoder Dairy Series: A Horsefly Named Mo",
    description: "Join Mo the Horsefly and his Pegasus friend on magical adventures at the Yoder Dairy Farm! A heartwarming 10-volume children's series full of friendship, flying, and farm fun.",
    format: ["Children's Book", "10-Volume Series"],
    category: "Children's",
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/pegasus_farm.jpg`
  },
  {
    id: 7,
    title: "Echos of Resilience",
    description: "A MANUAL OF URBAN SURVIVAL — CHAPTER 1: THE SUB-BASEMENT & THE SOUL-EATERS. Forged in steel, rust, and firelight. A gritty field guide for those who refuse to break when the world goes dark. Stories of strength tempered in adversity, wisdom carved from the underground. CHAPTER 2 COMING SOON.",
    format: ["Book", "eBook", "Manual"],
    category: "Urban Survival",
    isNew: true,
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/echos_of_resilience_cover.jpg`
  },
  {
    id: 8,
    title: "Girl on an Island",
    description: "She's got the moves, the spirit, and a dream bigger than the stadium. A heartfelt animated story about a cheerleader who proves that determination conquers all.",
    format: ["Animated Movie", "Book"],
    category: "Inspirational",
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/girl_on_island_cover.png`
  },
  {
    id: 9,
    title: "When Lightning Strikes",
    description: "A MINDESIGN ENTERPRISES & JFRJR Original. When destiny calls, one boy must rise above the clouds. An electrifying animated adventure about courage, power, and finding your true calling.",
    format: ["Animated Movie", "Book"],
    category: "Inspirational",
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/when_lightning_strikes_cover.png`
  },
  {
    id: 10,
    title: "Wisdom for Friends",
    description: "A Companion Guide from the Love More Pillar. Heartfelt wisdom for life's journey - the perfect gift for those who matter most.",
    format: ["Book", "Gift Book"],
    category: "Spiritual Journey",
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/wisdom_for_friends_cover.png`
  },
  {
    id: 11,
    title: "BORRACHERO (Devil's Breath)",
    description: "FEAR IS YOUR WILL. LOSE THE MEMORY. LOSE YOURSELF. A chilling psychological thriller about the world's most dangerous drug and the dark forces that control it. A Film by Renato Mercado.",
    format: ["Movie", "Screenplay"],
    category: "Thriller",
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/borrachero_poster_new.png`
  },
  {
    id: 12,
    title: "The U-Haul Diaries",
    description: "BASED ON A TRUE STORY. HUSTLE. SURVIVE. REPEAT. THE 3-YEAR WILD RIDE. From Atlanta to everywhere, the true story of survival, grit, and the open road.",
    format: ["Movie", "Book", "Documentary"],
    category: "Gritty Reality",
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/uhaul_diaries_movie.png`
  },
  {
    id: 13,
    title: "God's Way vs My Way",
    description: "THE JOURNEY FROM CHAOS TO GRACE. A powerful spiritual memoir by J.F.R. Jr. exploring the crossroads between destruction and redemption, darkness and light.",
    format: ["Book", "eBook"],
    category: "Spiritual Journey",
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/gods_way_vs_my_way.png`
  },
  {
    id: 14,
    title: "Emotions in Motion",
    description: "A flowing masterpiece by Jose F. Rodriguez. Where music meets movement, and feelings take flight in waves of color and sound.",
    format: ["Album", "Book", "Art Collection"],
    category: "Inspirational",
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/emotions_in_motion.png`
  },
  {
    id: 15,
    title: "EARTHBOUND",
    description: "A MINDESIGN ENTERPRISES & JFRjr ORIGINAL. Two souls, one destiny. Where virtual meets reality, love transcends dimensions.",
    format: ["Movie", "Screenplay"],
    category: "Sci-Fi Romance",
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/earthbound_cover.png`
  },
  {
    id: 16,
    title: "A Bathroom's Tale",
    description: "FROM THE SEWERS OF ANOTHER DIMENSION! Filmed in TERROR-SCOPE! A MINDESIGN ENTERPRISES production. When the portal opens, nowhere is safe—especially the bathroom.",
    format: ["Movie", "Horror"],
    category: "Horror Comedy",
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/bathrooms_tale.png`
  },
  {
    id: 17,
    title: "The Root of All Evil",
    description: "HOW MUCH WOULD YOU PAY TO BECOME A MONSTER? A FILM BY J.F.R. JR. — Mindesign Enterprises presents a chilling exploration of greed, surveillance, and the price of ambition. Private feeds. Repressed truths. A psychological thriller that cuts to the core of what we'd become for power.",
    format: ["Movie", "Book", "Screenplay"],
    category: "Thriller",
    isNew: true,
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/root_of_all_evil_v2.png`
  },
  {
    id: 18,
    title: "The Pattern",
    description: "ONCE YOU SEE IT. REAL. YOU CAN'T UNSEE IT. JFRjr & Mindesign Enterprises presents a mind-bending sci-fi thriller. The microwave was just the beginning.",
    format: ["Movie", "Screenplay"],
    category: "Sci-Fi Thriller",
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/the_pattern_cover.png`
  },
  {
    id: 20,
    title: "THE VELOCITY LOCK",
    description: "JFRJR & MINDESIGN ENTERPRISES. THE MILLION DOLLAR LEASH. The race of a lifetime — speed is the key, but the lock... that's where destiny waits. A high-octane thriller that will leave you breathless.",
    format: ["Movie", "Screenplay"],
    category: "Action Thriller",
    isNew: true,
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/velocity_lock_poster_new.png`
  },
  {
    id: 21,
    title: "The 13th Million",
    description: "THE LEASE IS UP. THE ORIGINAL OWNERS ARE BACK. Deep-crust sonar indicates a rhythmic vibration starting at 13 million BCE. It's a timer. The stones are not the machine—they are the heatsinks. A mind-bending sci-fi epic with its companion comic series.",
    format: ["Book", "Comic Series", "Screenplay"],
    category: "Sci-Fi Epic",
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/13th_million_cover.png`
  },
  {
    id: 22,
    title: "The Lion & The Hummingbird",
    description: "SACRIFICE. REINCARNATION. RESTORATION. A JFRJR Original Mindesign Enterprises idea. In a world devastated by humanity's failures, an unlikely pair must find their way back to save us all. An epic tale of redemption and hope.",
    format: ["Book", "Animated Movie", "Screenplay"],
    category: "Inspirational Epic",
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/lion_and_hummingbird_cover.png`
  },
  {
    id: 23,
    title: "Guardian Angel",
    description: "IN THE GRITTY STREETS OF TEXAS, HOPE IS UNDER SIEGE. When the celestial bureaucracy fails, a renegade angel must go 'off-grid' to save the invisible. A blue-collar fight for the soul of the Hill Country. Featuring MICK, SARA, and BULL. Original Music by JFRJR.",
    format: ["Movie", "Screenplay", "Original Soundtrack"],
    category: "Supernatural Action",
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/guardian_angel_poster.png`
  },
  {
    id: 25,
    title: "The Deadline Protocol",
    description: "A MINDESIGN ENTERPRISES JFRJR ORIGINAL. 02:00:00:00. A blacklisted mercenary is exiled to a self-sustaining island of addicts, where he has two years to build a new civilization, find the woman he loves, and earn a pass home — unless the New World Order's final supply of drugs, or the true nature of the 'pass,' destroys them first. NWO PROTOCOL // SGN-1.",
    format: ["Movie", "Screenplay", "Book"],
    category: "Dystopian Thriller",
    isNew: true,
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/deadline_protocol_poster.png`
  },
  {
    id: 26,
    title: "The Far Side Discovery: Artemis II",
    description: "A FICTIONAL FANTASY THRILLER. When Artemis II crew deploys to the Advanced Anomaly Facility on the lunar far side, a swirling gateway of orange, green, and black energy rips open reality itself. What — or who — was waiting for us on the other side of the Moon? A MINDESIGN ENTERPRISES production. Written by Jose Francisco Rodriguez Jr. & Christie Lynn Herman.",
    format: ["Movie", "Screenplay"],
    category: "Sci-Fi Fantasy",
    isNew: true,
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/far_side_discovery_poster.jpg`
  },
  {
    id: 27,
    title: "The Barrier Protocol",
    description: "A MINDESIGN ENTERPRISES PRESENTATION. FROM VETERAN PRODUCERS. At the edge of the frozen north, a colossal wall rises between our world and what the Earth has been hiding. One man. One helmet. One breach away from the truth beneath the ice.",
    format: ["Movie", "Screenplay"],
    category: "Sci-Fi Thriller",
    isNew: true,
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/barrier_protocol_poster.png`
  },
  {
    id: 28,
    title: "LIVE MORE. LOVE MORE. LAUGH MORE. GIVE MORE.",
    description: "17 COUNTY JAILS. NO CEILINGS HERE! MINDESIGN ENTERPRISES LLC JFRJR Presents a raw, real talk 24/7 — the practice of a lifetime. A 40-minute show. Gritty. Dynamic. Unfiltered. The Four Pillars, brought to the stage.",
    format: ["Live Performance", "Tour Poster", "The Four Pillars"],
    category: "Empowerment",
    isNew: true,
    isBookable: true,
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/no_ceilings_here_poster_v2.png`
  },
  {
    id: 29,
    title: "Emotions in Motion",
    description: "ORIGINAL POETRY & LYRICS by Jose F. Rodriguez Jr. — a raw, unfiltered collection spanning two decades of song. From 'Face Your Fear' to 'God's Way vs My Way', 'Triumphant', 'Drug Addict', 'Dear Younger Me', 'The Shine' and dozens more. Faith, fall, addiction, redemption, love, grit — the soul of MINDESIGN MUSIC laid bare on the page.",
    format: ["Book", "eBook", "Poetry", "Lyrics"],
    category: "Poetry & Lyrics",
    isNew: true,
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/emotions_in_motion_cover.png`
  },
  {
    id: 30,
    title: "The 8th Epoch",
    description: "A MINDESIGN ENTERPRISES JFRJR ORIGINAL PRODUCTION. WE ARE NOT THE FIRST. WE WILL NOT BE THE LAST. Cities crumble as the eye of the cosmos opens above the skyline — civilizations past and future converge through the pyramid gateway. From the ruins of empires to the alien architects who came before, one survivor stands at the threshold of the next epoch. STREAMING ON NETFLIX — coming soon.",
    format: ["Movie", "Streaming Series", "Screenplay"],
    category: "Sci-Fi Epic",
    isNew: true,
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/the_8th_epoch_poster.png`
  },
  {
    id: 31,
    title: "Starfall Genesis",
    description: "FROM MINDESIGN ENTERPRISES. TO SAVE THE STARS, THEY MUST FIND A NEW WAY. A JFRJR Production — written and directed by JF Keepin' It Real & Love Bug. Music by THE REDACTED. When the cosmos itself begins to fail, an unlikely crew of starfarers chases the last spark of creation across a dying galaxy. Cinematic, hopeful, epic.",
    format: ["Movie", "Original Soundtrack", "Screenplay"],
    category: "Sci-Fi Fantasy",
    isNew: true,
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/starfall_genesis_poster.png`
  },
  {
    id: 32,
    title: "Remorse",
    description: "A MINDESIGN ENTERPRISES JFRJR ORIGINAL. WHEN LIFE HANDS YOU LEMONS. Written & directed by J.F. Rodriguez Jr. Two souls — one drowning in grief on a rain-soaked street, one bathed in golden light holding the box that could change everything. A split-panel meditation on choice, consequence, and the second chance you didn't think you deserved.",
    format: ["Movie", "Screenplay", "Drama"],
    category: "Drama",
    isNew: true,
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/remorse_poster.png`
  },
  {
    id: 33,
    title: "The Analog Colony",
    description: "A MINDESIGN ENTERPRISES PRODUCTION. EVERY SECOND DATA-MINED. EVERY THOUGHT OPTIMIZED. THE ULTIMATE DIGITAL DETOX IS A LIE. A made-for-TV drama and lifestyle thriller. Four seekers retreat to a hand-crafted cottage paradise — only to discover the chief behavioral architect has wired their every breath into the recursive horizon glitch. Find your authenticity… if it's real. Filmed in association with The Rodriguez Family Trust.",
    format: ["TV Movie", "Drama", "Lifestyle Thriller"],
    category: "Sci-Fi Thriller",
    isNew: true,
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/analog_colony_poster.png`
  },
  {
    id: 34,
    title: "The Blackened Emerald",
    description: "A MINDESIGN ENTERPRISES PRESENTATION. THE RIOTS WERE A DIVERT. THE HEIST WAS REAL. THE BLACKENED EMERALD EXPOSES THE TRUTH. Seattle burns while a billion-dollar chip is lifted from the tower. One investigative journalist with a shattered tablet holds the only frame of the real story. Conspiracy, corporate misdirection, and the weight of a single leaked truth.",
    format: ["Movie", "Screenplay", "Investigative Thriller"],
    category: "Thriller",
    isNew: true,
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/blackened_emerald_poster.png`
  },
  {
    id: 35,
    title: "The Weight of the Sky",
    description: "MINDESIGN ENTERPRISES presents a JFRJR ORIGINAL. THE DREAMS AREN'T WARNINGS. THEY'RE INSTRUCTIONS. This summer — Jason Hansen isn't predicting the tragedy. He is creating it. Tail numbers, GPS coordinates, blueprints scrawled in a child's hand and pinned to the wall. Cast: Jason Hansen · Liam Miller · Sarah Jones. Directed by J.F.R. Jr. Written by L.S. Smith.",
    format: ["Movie", "Screenplay", "Psychological Thriller"],
    category: "Thriller",
    isNew: true,
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/weight_of_the_sky_poster.png`
  },
  {
    id: 36,
    title: "The Bureaucracy of Everything: Tier 3 Living",
    description: "A MINDESIGN ENTERPRISES JFRJR ORIGINAL SERIES. GETTING BY IS EXPENSIVE. In a Tier 3 smart city, the shower buffers, the door is a 5.99-credit unlock, and the TOS scrolls forever. A dystopian satire about subscription survival, micro-transaction dignity, and the EULA that ate the world. Terms and conditions *apply* to *everything*.",
    format: ["Streaming Series", "Dystopian Satire", "Screenplay"],
    category: "Sci-Fi Thriller",
    isNew: true,
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/bureaucracy_of_everything_poster.png`
  },
  {
    id: 37,
    title: "THEM",
    description: "A MINDESIGN ENTERPRISES PRESENTATION. A JFRJR ORIGINAL. SMALL SINS. BIG WEBS. The vices you ignored grow legs. The relics of indulgence — magazines, candies, collars — become breadcrumbs to the things waiting in the dark beneath the city. Visit Hell this summer. Written by JFRJR and MINDESIGN ENTERPRISES.",
    format: ["Movie", "Horror", "Screenplay"],
    category: "Horror",
    isNew: true,
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/them_poster.png`
  },
  {
    id: 38,
    title: "The New Guard: Riot Women",
    description: "A MINDESIGN BODY OF WORK — SOCIAL RESTORATION PROJECT. IN THE AGE OF ALGORITHMS, JUSTICE NEEDS A SOUL. Dallas. Seattle. Incognito. Five women — ELENA, SARAH, CASS, JO, ROXIE — go off-grid to blow the top off this gold mine. Featuring THE REDACTED soundtrack: 'The Shine', 'Cold World', 'I Can Show You', 'The Grime', 'She Humbled', 'Mean Season'. You never know what's coming.",
    format: ["TV Series", "Original Soundtrack", "Screenplay"],
    category: "Action Thriller",
    isNew: true,
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/new_guard_riot_women_poster.png`
  }
];

export const musicData = [
  {
    id: 1,
    title: "The Redacted's Lair",
    duration: "4:23",
    genre: "Rock",
    description: "Enter the domain of THE REDACTED",
    videoUrl: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/redacteds_lair.mp4`,
    thumbnail: "https://images.pexels.com/photos/34594386/pexels-photo-34594386.jpeg"
  },
  {
    id: 2,
    title: "Redesigned Soul",
    duration: "3:47",
    genre: "Alternative",
    description: "A sonic journey through transformation",
    videoUrl: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/redesigned_soul.mp4`,
    thumbnail: "https://images.pexels.com/photos/5749200/pexels-photo-5749200.jpeg"
  },
  {
    id: 3,
    title: "Legacy in Motion",
    duration: "5:12",
    genre: "Instrumental",
    description: "Cinematic soundscapes for the bold",
    videoUrl: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/legacy_in_motion.mp4`,
    thumbnail: "https://images.pexels.com/photos/34594386/pexels-photo-34594386.jpeg"
  },
  {
    id: 4,
    title: "After Dark Chronicles",
    duration: "4:56",
    genre: "Rock",
    description: "Where shadows meet sound",
    videoUrl: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/after_dark_chronicles.mp4`,
    thumbnail: "https://images.pexels.com/photos/5749200/pexels-photo-5749200.jpeg"
  },
  {
    id: 5,
    title: "Empowerment Anthem",
    duration: "3:34",
    genre: "Motivational",
    description: "The soundtrack to your breakthrough",
    videoUrl: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/empowerment_anthem.mp4`,
    thumbnail: "https://images.pexels.com/photos/34594386/pexels-photo-34594386.jpeg"
  },
  {
    id: 6,
    title: "Four Pillars Suite",
    duration: "6:18",
    genre: "Orchestral",
    description: "Musical philosophy in four movements",
    videoUrl: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/four_pillars_suite.mp4`,
    thumbnail: "https://images.pexels.com/photos/5749200/pexels-photo-5749200.jpeg"
  },
  {
    id: 7,
    title: "The Vault Sessions",
    duration: "4:08",
    genre: "Garage Rock",
    description: "Raw, unedited cuts from inside the REDACTED vault",
    videoUrl: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/mindesign_extra_video.mp4`,
    thumbnail: "https://images.pexels.com/photos/34594386/pexels-photo-34594386.jpeg"
  }
];

export const fourPillarsData = [
  {
    id: 1,
    pillar: "Mental Fortitude",
    icon: "brain",
    description: "Master your mind to master your reality. Build unshakeable mental resilience.",
    practices: ["Daily reflection", "Strategic thinking", "Mindful awareness"]
  },
  {
    id: 2,
    pillar: "Physical Excellence",
    icon: "dumbbell",
    description: "Your body is the vessel of your legacy. Honor it with discipline and care.",
    practices: ["Consistent movement", "Nutrition mastery", "Rest and recovery"]
  },
  {
    id: 3,
    pillar: "Spiritual Connection",
    icon: "compass",
    description: "Find your north star. Connect to something greater than yourself.",
    practices: ["Purpose seeking", "Value alignment", "Inner peace cultivation"]
  },
  {
    id: 4,
    pillar: "Creative Expression",
    icon: "palette",
    description: "Your story is your power. Express it boldly and authentically.",
    practices: ["Artistic exploration", "Voice discovery", "Legacy building"]
  }
];

export const statsData = [
  { label: "Original Stories", value: "30+", description: "For TV, Movies, Books & Comics" },
  { label: "Songs & Soundscapes", value: "150+", description: "Original compositions" },
  { label: "Formats", value: "5+", description: "Book, eBook, Audio, Comic, Video" },
  { label: "Years Creating", value: "30", description: "Building the MINDESIGN VAULT" }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Michael Torres",
    role: "Reader & Music Enthusiast",
    quote: "MINDESIGN changed my perspective on life. The raw honesty in the Meth Chronicles paired with the powerful soundtracks created a transformative experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Chen",
    role: "Creative Professional",
    quote: "The Four Pillars philosophy has become my daily compass. Jose's work bridges art and actionable wisdom beautifully.",
    rating: 5
  },
  {
    id: 3,
    name: "David Martinez",
    role: "Navy Veteran",
    quote: "As a fellow veteran, I deeply connect with the discipline and raw authenticity in this work. Truly inspiring.",
    rating: 5
  }
];

// Comics Data
export const comicsData = [
  {
    id: 1,
    title: "The Unfortunate Adventures of Chokey & Hackenberry",
    description: "FAME IS FLEETING. MUNCHIES ARE FOREVER. OUR FLAGSHIP COMIC — 19K+ VIEWS AND CLIMBING. Two washed-up '90s mascots, Chokey the Bear and Hackenberry the California Raisin, navigate their post-fame lives with nachos, Pepsi, and questionable business plans. From Dry Valley to DEFCON 1 — Government Fruitism, The Gary Conundrum, POTUS Twins, Judge Judy, Christie's arrival, and the Final Lockdown Beep! A MINDESIGN ENTERPRISES PRODUCTION.",
    series: "Chokey & Hackenberry",
    issue_number: 1,
    category: "Adult Comedy",
    format: ["Comic", "Flagship Series"],
    isFlagship: true,
    isNew: true,
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_hackenberry_poster.jpg`,
    pages: [
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_ep_dry_valley.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_ep_panic_stations.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_ep_panic_point.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_ep_nuisance.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_ep_strategy.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_ep_darkness.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_ep_standoff.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_ep_defcon.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_ep_cauli_ht.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_hackenberry_ep1.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_hackenberry_ep2.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_hackenberry_ep3.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_hackenberry_ep4.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_hackenberry_ep5.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_hackenberry_ep6.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_hackenberry_ep7.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_hackenberry_ep8.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_hackenberry_comic_1.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_hackenberry_comic_2.png`
    ]
  },
  {
    id: 2,
    title: "Daffy Dork: The Lonely Leviathan's Lament",
    description: "A funny satirical adult comic about a freed deceased whale's reproductive member. Sebastian the whale failed to satisfy his life's mission before passing. So his Dork, Daffy, must now fulfill the mission left behind. He doesn't get it—besides, he's a drunk and that's it. His best friend is Brianna Bandaid.",
    series: "Daffy Dork",
    issue_number: 1,
    category: "Adult Comedy",
    format: ["Comic"],
    coverImage: "https://customer-assets.emergentagent.com/job_transmedia-hub-1/artifacts/gl5rmhfx_1000004764.jpg",
    pages: [
      "https://customer-assets.emergentagent.com/job_transmedia-hub-1/artifacts/osv57mn2_1000004761.jpg",
      "https://customer-assets.emergentagent.com/job_transmedia-hub-1/artifacts/f97uzy2f_1000004762.jpg",
      "https://customer-assets.emergentagent.com/job_transmedia-hub-1/artifacts/hbiza2xb_1000004763.jpg",
      "https://customer-assets.emergentagent.com/job_transmedia-hub-1/artifacts/uh41yp5b_1000004759.jpg"
    ]
  },
  {
    id: 3,
    title: "THE REDACTED: The Enigma - Origin",
    description: "The Redacted Protocol. Activated. 'We were never born. Only synthesized.' Witness the origin of the mysterious band that exists between dimensions. They called us THE REDACTED. The Enigma. Now, the world listens.",
    series: "THE REDACTED",
    issue_number: 1,
    category: "Sci-Fi",
    format: ["Comic"],
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/REDACTED_comic_origin.png`,
    pages: [
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/REDACTED_comic_origin.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/REDACTED_comic_draconic.png`
    ]
  },
  {
    id: 4,
    title: "U-Haul Diaries",
    description: "To move the future, you must first remember where you left the past. Elisa's journey through the Mindesign Ecosystem - sweat, stale coffee, and the lies you told to get the deposit back. The diaries aren't lost. They are a training manual.",
    series: "U-Haul Diaries",
    issue_number: 1,
    category: "Sci-Fi Drama",
    format: ["Comic"],
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/uhaul_diaries_comic.png`,
    pages: [
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/uhaul_diaries_comic.png`
    ]
  },
  {
    id: 5,
    title: "The 13th Million",
    description: "THE LEASE IS UP. THE ORIGINAL OWNERS ARE BACK. Deep-crust sonar indicates a rhythmic vibration starting at 13 million BCE. It's a timer. The stones are not the machine—they are the heatsinks.",
    series: "The 13th Million",
    issue_number: 1,
    category: "Sci-Fi Thriller",
    format: ["Comic"],
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/13th_million_cover.png`,
    pages: [
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/13th_million_cover.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/13th_million_comic.png`
    ]
  },
  {
    id: 6,
    title: "Window Warriors: The Adventures of BeeBee, Baby & Shy",
    description: "DREAMING BIG. STAYING PUT. Three indoor cats—BeeBee the queen, Baby the sneezer, and Shy the treat hunter—navigate the mysteries of the great indoors. Red dots, rainy days, and the eternal quest for snacks.",
    series: "Window Warriors",
    issue_number: 1,
    category: "Comedy",
    format: ["Comic"],
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/window_warriors_cover.png`,
    pages: [
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/window_warriors_cover.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/window_warriors_ep2.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/window_warriors_ep3.png`
    ]
  },
  {
    id: 7,
    title: "Hanford Glows",
    description: "REALITY JUST SPRUNG A LEAK. When Marco hits rock bottom in a gas station bathroom, he discovers a glowing portal to another dimension. The hustle just went supernatural!",
    series: "Hanford Glows",
    issue_number: 1,
    category: "Sci-Fi Comedy",
    format: ["Comic"],
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/hanford_glows_comic.png`,
    pages: [
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/hanford_glows_comic.png`
    ]
  },
  {
    id: 8,
    title: "The Lion and The Hummingbird: Chapter One - Born of Flame",
    description: "A WORLD AWAKENS... IN FIRE AND MIRE. Each day a struggle, through a burning sludge. But look beyond the ash! The 'Outlier' dances... A tale of sacrifice, reincarnation, and restoration. JFRJR Original - MINDESIGN ENTERPRISES.",
    series: "The Lion and The Hummingbird",
    issue_number: 1,
    category: "Inspirational Epic",
    format: ["Comic"],
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/lion_hummingbird_page1.png`,
    pages: [
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/lion_hummingbird_page1.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/lion_hummingbird_page2.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/lion_hummingbird_page3.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/lion_hummingbird_page4.png`
    ]
  },
  {
    id: 10,
    title: "Guardian Angel: The Mesh is Online",
    description: "IN THE GRITTY STREETS OF TEXAS, HOPE IS UNDER SIEGE. Elias 'Eli' Thorne, 40s, rugged, weary — a faded Navy ballcap and a torque wrench against the Karma Ledger. Critical Latency: Sector 78063. When the Cloud fails, we go Analog. Let 'em come — The Mesh is online. A JFRJR Original.",
    series: "Guardian Angel",
    issue_number: 1,
    category: "Supernatural Action",
    format: ["Comic"],
    coverImage: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/guardian_angel_comic_p1.png`,
    pages: [
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/guardian_angel_comic_p1.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/guardian_angel_comic_p2.png`
    ]
  }
];

// Blog Posts - WHATCHU TAWKIN' BOUT?
export const blogPosts = [
  {
    id: 0,
    title: "A Moment With God: My Chrysalis Moment in the North Tower",
    excerpt: "Christmas morning 2021. Iron doors grinding open in the Dallas County Jail. COVID running rampant. The night I gave my soul to Christ — and the night God showed me my failures were the foundation for my testimony.",
    content: `Christmas morning 2021. As I reflect upon my life it's 4:13 a.m. and all is good — peace is in the air. Then I am distracted by the mechanical sounds of the heavy, iron prison doors grinding and rattling open in the North Tower of the Dallas County Jail.

It's old, very used, and spiritually dead. Worn, once-painted walls and floors describe a peek at a system that's abused its power. I can only imagine the shame, humility, heartache, pain, and terror that has filled the hearts and minds of the tens of thousands of human animals that have shed a bit of their soul in this very cell.

**THE NIGHT I TURNED**

With COVID in full swing, I assumed I would get a break. There would be no such luck. I had the privilege of acquiring the virus twice in three and a half months. Social distancing was non-existent. Hope was a luxury we couldn't afford.

I turned to my Creator and Savior Jesus Christ and began the process of spending some much needed time with our most high God — and decided to document the process.

**THE PROMISE**

When I began this book I was really unsure of many things, and God quickly took my hand and showed me that I had nothing to worry about. He would speak to me with clarity, and instill a feeling in me that he would move the right people to distribute my books and literature throughout the world as a testament to his amazing grace and love.

He showed me that my life — the failures, the addiction, the wasted years — was the one He was using. He was simply putting the gifts I thought I'd wasted in place, so when it was my time, I could and would share them with the world.

**THE ROOT OF FEAR**

Love is the light of emotional man — fear is the darkness. From fear we get hate, envy, jealousy, greed, and the mother of all hatred.

Fear comes from not trusting something to be what we believe or expect. Faith is the trusting that all will be okay. Anger is a premeditated response of those who are afraid and impatient.

The brilliant Holocaust survivor Victor Frankl proved that even in the face of unimaginable horror, humans are the only mammal to recognize a space between stimulus and response. We choose our reaction. In that critical space, you have a choice: choose patience, choose forethought, choose God's love, or choose the darkness of fear.

**LIVE MORE · LOVE MORE · LAUGH MORE · GIVE MORE**

This memoir is the unedited, real-time documentation of an eight-month meditation. Read the full Chrysalis journey in the Literary Works section.

Your Life, Redesigned. With God.`,
    category: "Spiritual Journey",
    readTime: "9 min read",
    trending: true,
    featured: true,
    views: "New",
    date: "Just released",
    author: "Jose Francisco Rodriguez Jr.",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/moment_with_god_cover.png`,
    linkedBook: "A Moment With God"
  },
  {
    id: 1,
    title: "The Art of Redesigning Your Reality: Why Most People Stay Stuck",
    excerpt: "Yo, real talk—most people ain't living, they just existing. Here's why you're stuck in the same loop and how to break free using the Four More principles.",
    content: `Listen up, because I'm about to drop some truth bombs that might make you uncomfortable. But that's the point, isn't it?

You wake up. Same routine. Same complaints. Same excuses. Different day, same you. Sound familiar?

Here's the harsh reality: You're not stuck because life dealt you a bad hand. You're stuck because you keep playing the same cards the same way, expecting different results. That's insanity, fam.

**THE REDESIGN BLUEPRINT**

Living more means taking risks. Love more means being vulnerable. Laugh more means not taking yourself so seriously. Give more means putting others first sometimes.

But here's what nobody tells you—redesigning your life ain't comfortable. It's messy, it's scary, and it's going to piss off people who benefit from you staying small.

The question isn't whether you CAN change. It's whether you're willing to endure the discomfort of growth long enough to see the transformation.

Your move.`,
    category: "Philosophy",
    readTime: "5 min read",
    trending: true,
    views: "12.5K",
    date: "2 hours ago",
    author: "Jose Francisco Rodriguez Jr.",
    image: "https://images.unsplash.com/photo-1759207027215-28106e5de290"
  },
  {
    id: 2,
    title: "Why Your 'Friends' Don't Want You to Succeed (And What to Do About It)",
    excerpt: "Not everyone in your circle wants to see you win. Some are comfortable with you being at their level. This is how you identify them and what to do next.",
    content: `This one's gonna hurt, but someone's gotta say it.

That friend who always has something negative to say when you share good news? The one who tells you to "be realistic" when you talk about your dreams? The person who suddenly gets quiet when you achieve something? Yeah, them.

**THE UNCOMFORTABLE TRUTH**

Some people in your life have invested in the version of you that makes THEM feel better about their choices. When you start leveling up, it holds up a mirror to what they're NOT doing with their lives.

That's uncomfortable for them. So they'll try to pull you back down. Not because they're evil—because they're scared.

**THE MINDESIGN APPROACH**

Live More: Distance yourself from energy vampires
Love More: But wish them well from afar
Laugh More: Don't take their negativity personally
Give More: Inspire others who actually want to grow

Your circle should be a trampoline, not an anchor. Choose wisely.`,
    category: "Life Lessons",
    readTime: "6 min read",
    trending: true,
    views: "18.3K",
    date: "5 hours ago",
    author: "Jose Francisco Rodriguez Jr.",
    image: "https://images.unsplash.com/photo-1759917741924-50fb1dddeb88"
  },
  {
    id: 3,
    title: "From Rock Bottom to Rock Solid: The Meth Chronicles Journey",
    excerpt: "Raw, unfiltered truth about hitting rock bottom and clawing your way back up. No sugar-coating, no fairy tales—just survival, resilience, and redemption.",
    content: `They say you have to hit rock bottom before you can bounce back. That's partially true. What they don't tell you is that rock bottom has a basement.

**THE ABYSS**

The Meth Chronicles trilogy wasn't written from an ivory tower. It was bled onto pages from the darkest corners of human experience. Every character, every struggle, every moment of desperation—that's real life distilled into ink.

People ask me, "How do you write about such dark stuff?" Easy. I lived it. I survived it. Now I transform it.

**THE CLIMB OUT**

Here's what saved me:
- Accepting I was the problem AND the solution
- Building mental fortitude brick by brick
- Finding purpose in the pain
- Using creativity as therapy

The Four More philosophy wasn't born in a boardroom. It was forged in the fire of surviving what should have destroyed me.

**YOUR TURN**

If you're in that dark place right now, hear me: You're not done yet. The story isn't over. This is just the chapter where the hero faces their greatest challenge.

What comes next? That's up to you.

Your Life, Redesigned.`,
    category: "Personal Story",
    readTime: "8 min read",
    trending: true,
    views: "24.7K",
    date: "1 day ago",
    author: "Jose Francisco Rodriguez Jr.",
    image: "https://images.pexels.com/photos/5625918/pexels-photo-5625918.jpeg"
  }
];

// Shop Products - GITCHA SUM GOODIES
export const shopProducts = [
  {
    id: 1,
    name: "SPUN BY SPUN: AFTER DARK Hoodie",
    description: "Premium all-over print hoodie. Cyberpunk aesthetic. Limited edition design.",
    price: 79.99,
    category: "Apparel",
    image: "https://customer-assets.emergentagent.com/job_transmedia-hub-1/artifacts/itsdmai5_1000007292.png",
    sizes: ["S", "M", "L", "XL", "XXL"],
    bestseller: true,
    inStock: true,
    featured: true
  },
  {
    id: 2,
    name: "METH CHRONICLES Official Hoodie",
    description: "Explosive graffiti-style print. MINDESIGN & JFRjr exclusive production.",
    price: 74.99,
    category: "Apparel",
    image: "https://customer-assets.emergentagent.com/job_transmedia-hub-1/artifacts/wsm0hbtn_1000007294.png",
    sizes: ["S", "M", "L", "XL", "XXL"],
    bestseller: true,
    inStock: true,
    featured: true
  },
  {
    id: 3,
    name: "THE 13TH MILLION Complete Bundle",
    description: "Premium bundle: Hoodie, T-shirt, Mug, Cap, Dog Tags, and Journal. Everything you need.",
    price: 149.99,
    originalPrice: 199.99,
    category: "Bundles",
    image: "https://customer-assets.emergentagent.com/job_transmedia-hub-1/artifacts/9eb2h6qm_1000007287.png",
    bestseller: true,
    inStock: true,
    featured: true,
    bundle: true
  },
  {
    id: 4,
    name: "BORRACHERO Merch Collection",
    description: "Full set: Hoodie, T-shirt, Mug, and Cap. 'Lose the Memory, Lose the Yourself. Fear is Normal.'",
    price: 134.99,
    originalPrice: 169.99,
    category: "Bundles",
    image: "https://customer-assets.emergentagent.com/job_transmedia-hub-1/artifacts/wifn5lzt_1000007286.png",
    inStock: true,
    bundle: true
  },
  {
    id: 5,
    name: "PARALLELS Reality Collection",
    description: "Complete bundle: Hoodie, T-shirt, Mug, Cap. 'Reality is Lie' - MINDESIGN ENTERPRISES production.",
    price: 139.99,
    originalPrice: 174.99,
    category: "Bundles",
    image: "https://customer-assets.emergentagent.com/job_transmedia-hub-1/artifacts/s855k2i5_1000007285.png",
    inStock: true,
    featured: true,
    bundle: true
  },
  {
    id: 6,
    name: "B3d PRISTINE HOME & OFFICE CLEANING Bundle",
    description: "Premium white collection: Hoodie, Sweatpants, Cap, Mug, Poster. Vibrant paint splatter design by MINDESIGN ENTERPRISES.",
    price: 159.99,
    originalPrice: 199.99,
    category: "Bundles",
    image: "https://customer-assets.emergentagent.com/job_transmedia-hub-1/artifacts/n8ug5neq_1000007297.png",
    inStock: true,
    featured: true,
    bundle: true
  },
  {
    id: 7,
    name: "MIDNIGHT PROJECT Cyberpunk Hoodie",
    description: "Back print: Brain-tech fusion design. 'The real Human Reality.' Premium quality hoodie.",
    price: 74.99,
    category: "Apparel",
    image: "https://customer-assets.emergentagent.com/job_transmedia-hub-1/artifacts/sxpin6ma_1000007283.png",
    sizes: ["S", "M", "L", "XL", "XXL"],
    inStock: true,
    featured: true
  },
  {
    id: 8,
    name: "Meth Chronicles Trilogy Box Set",
    description: "Complete trilogy in one powerful collection. Raw, honest, transformative.",
    price: 49.99,
    originalPrice: 65.97,
    category: "Books",
    image: "https://images.pexels.com/photos/6387583/pexels-photo-6387583.jpeg",
    bestseller: true,
    inStock: true
  },
  {
    id: 9,
    name: "LIVE MORE Signature T-Shirt",
    description: "Premium cotton tee with chrome LIVE MORE print. Unisex fit.",
    price: 29.99,
    category: "Apparel",
    image: "https://images.pexels.com/photos/8532616/pexels-photo-8532616.jpeg",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: ["Black", "Gunmetal Gray", "White"],
    inStock: true
  },
  {
    id: 10,
    name: "Daffy Dork Comic - Signed Edition",
    description: "Signed by the creator. Limited edition. Certificate of authenticity included.",
    price: 24.99,
    category: "Comics",
    image: "https://customer-assets.emergentagent.com/job_transmedia-hub-1/artifacts/gl5rmhfx_1000004764.jpg",
    limited: true,
    inStock: true
  },
  {
    id: 11,
    name: "Complete Soundscapes Digital Album",
    description: "All 70+ tracks. High-quality MP3/FLAC download. Instant delivery.",
    price: 34.99,
    originalPrice: 49.99,
    category: "Music",
    image: "https://images.pexels.com/photos/7948150/pexels-photo-7948150.jpeg",
    digital: true,
    bestseller: true,
    inStock: true
  },
  {
    id: 12,
    name: "Your Life Redesigned Journal",
    description: "Guided journal based on Four More principles. 200 pages.",
    price: 19.99,
    category: "Books",
    image: "https://images.pexels.com/photos/1591060/pexels-photo-1591060.jpeg",
    bestseller: true,
    inStock: true
  },
  {
    id: 13,
    name: "THE REDACTED Collection - Crimson Edition",
    description: "Premium hoodie, sweatpants, cap, and limited edition poster. THE REDACTED crimson colorway. 'The sound you cannot escape.' MINDESIGN ENTERPRISES exclusive.",
    price: 189.99,
    originalPrice: 249.99,
    category: "Bundles",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/merch_redacted_red.png`,
    bestseller: true,
    inStock: true,
    featured: true,
    bundle: true
  },
  {
    id: 14,
    name: "THE REDACTED Collection - Matrix Edition",
    description: "Premium hoodie, sweatpants, cap, and limited edition poster. THE REDACTED green matrix colorway. Enter the frequency. MINDESIGN ENTERPRISES exclusive.",
    price: 189.99,
    originalPrice: 249.99,
    category: "Bundles",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/merch_redacted_green.png`,
    bestseller: true,
    inStock: true,
    featured: true,
    bundle: true
  },
  {
    id: 15,
    name: "THE REDACTED Street Collection",
    description: "As worn by VANE and RYX. Premium streetwear featuring THE REDACTED signature designs. Hoodie + Sweatpants combo. Matrix green edition.",
    price: 149.99,
    originalPrice: 179.99,
    category: "Apparel",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/merch_redacted_models.png`,
    sizes: ["S", "M", "L", "XL", "XXL"],
    inStock: true,
    featured: true
  },
  {
    id: 16,
    name: "CHOKEY & HACKENBERRY — Purple Reign Collection",
    description: "FAME IS FLEETING. MUNCHIES ARE FOREVER. The full Chokey & Hackenberry drop in purple/green: hoodie (front + back print), dad cap (2 colorways), sweatpants with embroidery, woven tapestry, socks, enamel pin, and mug. MINDESIGN ENTERPRISES JFRJR Original.",
    price: 219.99,
    originalPrice: 289.99,
    category: "Bundles",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_merch_collection_purple.png`,
    sizes: ["S", "M", "L", "XL", "XXL"],
    bestseller: true,
    inStock: true,
    featured: true,
    bundle: true,
    isNew: true
  },
  {
    id: 17,
    name: "CHOKEY & HACKENBERRY — Deep Teal Collection",
    description: "FAME IS FLEETING. MUNCHIES ARE FOREVER. The full Chokey & Hackenberry drop in deep teal / olive: hoodie (front + back print), dad cap (2 colorways), embroidered sweatpants, woven tapestry, socks, enamel pin, and mug. MINDESIGN ENTERPRISES JFRJR Original.",
    price: 219.99,
    originalPrice: 289.99,
    category: "Bundles",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/chokey_merch_collection_teal.png`,
    sizes: ["S", "M", "L", "XL", "XXL"],
    inStock: true,
    featured: true,
    bundle: true,
    isNew: true
  },
  {
    id: 18,
    name: "MINDESIGN RADIO — Founder's Collection",
    description: "FUSING THE HUMAN HEART WITH AI ART. The complete MINDESIGN Radio fan kit: lion-crest tee, lightning Live More / Love More / Laugh More / Give More hoodie, woven Mindesign Radio tapestry, branded plush blanket, dad cap, embroidered sweatpants, stainless tumbler, M-compass carabiner, family-photo keychain, and the LAUGH MORE silver journal. Limited Founder's Collection — first 100 only.",
    price: 349.99,
    originalPrice: 449.99,
    category: "Bundles",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/mindesign_radio_founders_collection.png`,
    sizes: ["S", "M", "L", "XL", "XXL"],
    bestseller: true,
    inStock: true,
    featured: true,
    bundle: true,
    isNew: true
  },
  {
    id: 19,
    name: "MINDESIGN — Live More Studio Edition",
    description: "Lightning crackles. Vinyl spins. The radio that made you. Studio Edition bundle: heavyweight hoodie with the Four Pillars in lightning, MINDESIGN Radio raglan tee, stainless tumbler with vault badge, M-compass carabiner, LOVE MORE family keychain, and the LAUGH MORE silver journal. The everyday MINDESIGN uniform.",
    price: 199.99,
    originalPrice: 259.99,
    category: "Bundles",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/mindesign_radio_studio_edition.png`,
    sizes: ["S", "M", "L", "XL", "XXL"],
    inStock: true,
    featured: true,
    bundle: true,
    isNew: true
  },
  {
    id: 20,
    name: "MINDESIGN RADIO — Tapestry & Blanket Set",
    description: "FOR THE COUCH, THE WALL, THE LISTENING ROOM. Two-piece home set — the woven MINDESIGN RADIO tapestry (Lion crest, four-pillar border, fringe edges) plus the embroidered Live More / Love More / Laugh More / Give More plush blanket. Cinematic statement pieces for any MINDESIGN home or studio.",
    price: 119.99,
    originalPrice: 159.99,
    category: "Home",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/files/mindesign_radio_blanket_tapestry.png`,
    sizes: ["One Size"],
    inStock: true,
    featured: true,
    isNew: true
  }
];
